export { default as HighlightedDatePicker } from './src/date-picker-highlighted';
